const categories = {
  myBets: {
    id: 1,
    textIdent: 'myBets',
  },
  topWins: {
    id: 4,
    textIdent: 'topWins',
  },
  chat: {
    id: 5,
    textIdent: 'chat',
  },
  promoList: {
    id: 6,
    textIdent: 'promoList',
  },
}

export { categories };